import React, { useState, useEffect } from "react";
import {
  menuUrl,
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  tableConfig,
  tableControls as rawControls,
  filters as rawFilters,
} from "@screens/system/modules/modules-list/model/modules-list.constants";
import { getFilterData } from "@utils/common";
import {
  constructFilterDataAndGetQueryString,
  getFilterQueryString,
} from "@utils/filters.util";
import { APP, PRIMARY_KEY } from "@constants/app.constants";
import { useHistory } from "react-router-dom";
import { checkMenuAccess } from "@utils/menu-auth";
import {
  deleteModulesDataApi,
  getModulesDataApi,
} from "./modules-list.component.service";
import MESSAGES from "@constants/messages.constants";
import { useDispatch, useSelector } from "react-redux";
import { setAlertMessage } from "@reducers/alert.reducer";
import ModulesListTemplateComponent from "./modules-list-template.component";
import { editModulesApi } from "../modules-edit/modules-edit.component.service";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  MODULES_ALERTS: { DELETE_ALERT, EDIT_ALERT },
} = MESSAGES;
const { ROWS_PER_PAGE } = APP;

const ModulesListComponent = () => {
  const { filterList } = useSelector((state) => state.filter);
  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [tableControls, setTableControls] = useState(null);
  const [swapContentType, setSwapContentType] = useState(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const filters = getFilterData(filterList, menuUrl, "filter");
  const menuAccess = checkMenuAccess(menuUrl, "read");

  const getModulesData = async (params = null) => {
    // console.log({ params });
    const queryStr = getFilterQueryString(menuUrl, params);
    const modulesData = await getModulesDataApi({
      ...params,
      filters: queryStr,
    });
    if (modulesData.status) {
      // console.log(modulesData);
      setTableData(modulesData.data);
      setTotalCount(modulesData.totalCount);
    }
  };

  const handleCreateClick = () => {
    history.push(`/${menuUrl}/create`);
  };

  const deleteRecords = async (selected) => {
    const deleteAccess = checkMenuAccess(menuUrl, "delete");
    if (deleteAccess) {
      const response = await deleteModulesDataApi(selected);
      if (response.status) {
        dispatch(
          setAlertMessage({ type: SUCCESS, message: DELETE_ALERT, viewed: 0 })
        );
        getModulesData({
          orderBy: "created_at",
          sortBy: "desc",
          skip: 0,
          limit: ROWS_PER_PAGE,
        });
      } else {
        dispatch(
          setAlertMessage({ type: ERROR, message: response.message, viewed: 0 })
        );
      }
    } else
      dispatch(
        setAlertMessage({
          type: ERROR,
          message: "Permission denied to delete",
          viewed: 0,
        })
      );
  };

  const handleDownload = async (filters = null) => {
    const queryStr = getFilterQueryString(menuUrl, filters);
    // console.log("download triggered", filters, queryStr);
    // // console.log({
    //   url: `${SETTING_EXPORT}?token=${token}${queryStr}`,
    // });
  };

  const submitFilter = (filters) => {
    const queryStr = constructFilterDataAndGetQueryString(filters, menuUrl);
    // console.log({ queryStr });
    getModulesData({
      orderBy: "created_at",
      sortBy: "desc",
      skip: 0,
      limit: ROWS_PER_PAGE,
      filters: queryStr,
    });
  };

  const handleInlineEditSave = async (row) => {
    const editResponse = await editModulesApi(row[PRIMARY_KEY], row);
    if (editResponse.status) {
      dispatch(
        setAlertMessage({ type: SUCCESS, message: EDIT_ALERT, viewed: 0 })
      );
    }
  };

  const handleChartClick = ({ index, controls }) => {
    // console.log("chart click", tableControls);
    let copyControls = [...controls];
    copyControls[index].status = copyControls[index].status === 0 ? 1 : 0;
    // console.log({ status: copyControls[index].status });
    if (copyControls[index].status === 1) setSwapContentType("CHART");
    else setSwapContentType(null);
    setTableControls(copyControls);
  };

  const onLoad = () => {
    const updatedTableControls = rawControls.map((control) => {
      return {
        ...control,
        onClick: handleChartClick,
      };
    });
    setTableControls(updatedTableControls);
  };

  useEffect(() => {
    onLoad();
  }, []);

  return menuAccess ? (
    <ModulesListTemplateComponent
      templateModal={{
        tableTitle,
        keyColumn,
        breadCrumbs,
        tableColumn,
        tableData,
        totalCount,
        tableConfig,
        tableControls,
        swapContentType,
        filters: filters ? filters : rawFilters,
      }}
      templateEvents={{
        getModulesData,
        handleCreateClick,
        deleteRecords,
        handleDownload,
        submitFilter,
        handleInlineEditSave,
      }}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default ModulesListComponent;
